import {
    WidgetError,
    Settings,
    EditProfile,
    WidgetPasswordReset,
    WidgetSeeItInAction,
    UpgradeSubscription,
    UpgradeSubscriptionTeaser,
    UpgradeSubscriptionPayment,
    CancelSubscription,
    CancelSubscriptionSuccess,
    Personalise
} from '@S';

import Vue from 'vue';

Vue.component('WidgetPasswordReset', WidgetPasswordReset);
Vue.component('WidgetSeeItInAction', WidgetSeeItInAction);
Vue.component('EditProfile', EditProfile);
Vue.component('UpgradeSubscription', UpgradeSubscription);
Vue.component('UpgradeSubscriptionTeaser', UpgradeSubscriptionTeaser);
Vue.component('CancelSubscription', CancelSubscription);
Vue.component('Personalise', Personalise);

export default [
    {
        path: '/widget',
        name: 'top-level-settings',
        component: Settings
    },
    {
        path: '/widget/error',
        name: 'widget-error',
        component: WidgetError
    },
    {
        path: '/widget/upgrade-subscription-payment',
        name: 'widget-upgrade-subscription-payment',
        component: UpgradeSubscriptionPayment
    },
    {
        path: '/widget/cancelled-subscriptions-success',
        name: 'widget-cancelled-subscriptions-success',
        component: CancelSubscriptionSuccess
    },
    {
        path: '/widget/personalise',
        name: 'widget-personalise',
        component: Personalise
    }
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/widgets.js